import SafetyDatabaseObservationTypes from './safetyDatabaseObservation.types';
import { INITIAL_STATE } from '../safetyObservation/safetyObservation.reducer';
import cloneDeep from 'lodash/cloneDeep';

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SafetyDatabaseObservationTypes.DB_HYDRATE_OBSERVATION_FORM: {
			const { submission } = action.payload;

			return cloneDeep(submission);
		}
		case SafetyDatabaseObservationTypes.DB_UPDATE_ACTIVITY:
			return {
				...state,
				activity: {
					...state.activity,
					[action.payload.key]: {
						...state.activity[action.payload.key],
						value: action.payload.value
					}
				}
			};
		case SafetyDatabaseObservationTypes.DB_UPDATE_TYPE_OF_OBSERVATION:
			return {
				...state,
				type_of_observation: {
					...INITIAL_STATE.type_of_observation,
					[action.payload.key]: {
						...INITIAL_STATE.type_of_observation[action.payload.key],
						value: action.payload.value
					}
				}
			};
		case SafetyDatabaseObservationTypes.DB_UPDATE_CONDITION: {
			const { section, condition, safe, concern } = action.payload;
			const newState = cloneDeep(state);

			newState.conditions[section].fields[condition].safe = safe;
			newState.conditions[section].fields[condition].concern = concern;

			return newState;
		}
		case SafetyDatabaseObservationTypes.DB_UPDATE_TEXT_FIELD:
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case SafetyDatabaseObservationTypes.DB_UPDATE_HAZARD_STATUS:
			return {
				...state,
				hazard_status: action.payload
			};
		case SafetyDatabaseObservationTypes.DB_UPDATE_NEAR_MISSES:
			return {
				...state,
				near_misses: {
					...state.near_misses,
					[action.payload.key]: {
						...state.near_misses[action.payload.key],
						value: action.payload.value
					}
				}
			};
		case SafetyDatabaseObservationTypes.DB_UPDATE_DATE:
			return {
				...state,
				date: action.payload
			};
		default:
			return state;
	}
};
